var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0V1.33333H1.33333C0.6 1.33333 0 1.93333 0 2.66667V12C0 12.7333 0.6 13.3333 1.33333 13.3333H10.6667C11.4 13.3333 12 12.7333 12 12V2.66667C12 1.93333 11.4 1.33333 10.6667 1.33333H10V0H8.66667V1.33333H3.33333V0H2ZM1.33333 4.66667H10.6667V12H1.33333V4.66667Z",
    fill: "#979FA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClIc);
export default __webpack_public_path__ + "static/media/clIC.a3528e26ec847b02311ec196583adcae.svg";
export { ForwardRef as ReactComponent };